export default __webpack_public_path__ + "static/media/right-arrow-white.b0813fc1.svg";